export class DriveAndMachineContentModel {
  public driveAndMachineContentId: number;
  public medicineId: number;
  public driveDescription: string;
  public machineDescription: string;
}